var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMEncuestas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#2eccb6;}.cls-3{fill:#329be6;}.cls-4{fill:#0b5c96;}.cls-5{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_encuestas"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Encuestas"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.5,
    y: 10.5,
    width: 17,
    height: 9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41,8,33.28.28a.4.4,0,0,0-.56,0L25,8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "44 11 44 15 48 15 44 11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "22 11 18 15 22 15 22 11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.72,32.72,51,18V48L65.72,33.28A.4.4,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15,18,.28,32.72a.4.4,0,0,0,0,.56L15,48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26,59l6.72,6.72a.4.4,0,0,0,.56,0L40,59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.72,65.72a.4.4,0,0,0,.56,0L40,59H26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.28,32.72a.4.4,0,0,0,0,.56L15,48V18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "22 11 18 15 22 15 22 11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "48 15 44 11 44 15 48 15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.28.28a.4.4,0,0,0-.56,0L25,8H41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.72,32.72,51,18V48L65.72,33.28A.4.4,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.4,8a.4.4,0,0,0-.4.4V11l3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48,56H43l-3,3H50.6a.4.4,0,0,0,.4-.4V48l-3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18,56V51l-3-3V58.6a.4.4,0,0,0,.4.4H26l-3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.39,15a.4.4,0,0,0-.4.4V18l3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51,15.4a.4.4,0,0,0-.4-.4H48l3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44,8.4a.4.4,0,0,0-.4-.4H41l3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M48,15H44V11L41,8H25l-3,3v4H18l-3,3V48l3,3V18h4V21.6a.4.4,0,0,0,.4.4H43.6a.4.4,0,0,0,.4-.4V18h4V51l3-3V18Zm-6.5,4.5h-17v-9h17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "23.02 56.02 26 59 40 59 42.98 56.02 23.02 56.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44,18V21.6a.4.4,0,0,1-.4.4H22.4a.4.4,0,0,1-.4-.4V18H18V56H48V18ZM28.64,47.2l-4.52,4.52a.39.39,0,0,1-.56,0l-2.44-2.44a.39.39,0,0,1,0-.56l1.2-1.21a.4.4,0,0,1,.56,0l1,1,3-3a.4.4,0,0,1,.57,0l1.2,1.2A.39.39,0,0,1,28.64,47.2Zm0-5.5-4.52,4.52a.4.4,0,0,1-.56,0l-2.44-2.44a.4.4,0,0,1,0-.57l1.2-1.2a.39.39,0,0,1,.56,0l1,1,3-3a.42.42,0,0,1,.57,0l1.2,1.2A.4.4,0,0,1,28.64,41.7Zm0-5.49-4.52,4.51a.39.39,0,0,1-.56,0l-2.44-2.43a.4.4,0,0,1,0-.57l1.2-1.2a.39.39,0,0,1,.56,0l1,.95,3-3a.4.4,0,0,1,.57,0l1.2,1.2A.4.4,0,0,1,28.64,36.21Zm0-5.51-4.52,4.52a.39.39,0,0,1-.56,0l-2.44-2.44a.39.39,0,0,1,0-.56L22.32,31a.4.4,0,0,1,.56,0l1,1,3-3a.4.4,0,0,1,.57,0l1.2,1.2A.39.39,0,0,1,28.64,30.7Zm0-5.5-4.52,4.52a.4.4,0,0,1-.56,0l-2.44-2.44a.4.4,0,0,1,0-.57l1.2-1.2a.39.39,0,0,1,.56,0l1,.95,3-3a.42.42,0,0,1,.57,0l1.2,1.2A.4.4,0,0,1,28.64,25.2ZM44,50.1a.4.4,0,0,1-.4.4H31.4a.4.4,0,0,1-.4-.4V48.4a.4.4,0,0,1,.4-.4H43.57a.4.4,0,0,1,.4.4Zm0-5.5a.4.4,0,0,1-.4.4H31.4a.4.4,0,0,1-.4-.4V42.9a.4.4,0,0,1,.4-.4H43.57a.4.4,0,0,1,.4.4Zm0-5.49a.4.4,0,0,1-.4.4H31.4a.4.4,0,0,1-.4-.4v-1.7a.4.4,0,0,1,.4-.4H43.57a.4.4,0,0,1,.4.4Zm0-5.51a.4.4,0,0,1-.4.4H31.4a.4.4,0,0,1-.4-.4V31.9a.4.4,0,0,1,.4-.4H43.57a.4.4,0,0,1,.4.4Zm0-5.5a.4.4,0,0,1-.4.4H31.4a.4.4,0,0,1-.4-.4V26.4a.4.4,0,0,1,.4-.4H43.57a.4.4,0,0,1,.4.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 31,
    y: 26,
    width: 12.97,
    height: 2.5,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.44,23.43a.42.42,0,0,0-.57,0l-3,3-1-.95a.39.39,0,0,0-.56,0l-1.2,1.2a.4.4,0,0,0,0,.57l2.44,2.44a.4.4,0,0,0,.56,0l4.52-4.52a.4.4,0,0,0,0-.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 31,
    y: 31.5,
    width: 12.97,
    height: 2.5,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.44,28.94a.4.4,0,0,0-.57,0l-3,3-1-1a.4.4,0,0,0-.56,0l-1.2,1.21a.39.39,0,0,0,0,.56l2.44,2.44a.39.39,0,0,0,.56,0l4.52-4.52a.39.39,0,0,0,0-.56Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 31,
    y: 37.01,
    width: 12.97,
    height: 2.5,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.44,34.44a.4.4,0,0,0-.57,0l-3,3-1-.95a.39.39,0,0,0-.56,0l-1.2,1.2a.4.4,0,0,0,0,.57l2.44,2.43a.39.39,0,0,0,.56,0l4.52-4.51a.4.4,0,0,0,0-.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 31,
    y: 42.5,
    width: 12.97,
    height: 2.5,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.44,39.93a.42.42,0,0,0-.57,0l-3,3-1-1a.39.39,0,0,0-.56,0l-1.2,1.2a.4.4,0,0,0,0,.57l2.44,2.44a.4.4,0,0,0,.56,0l4.52-4.52a.4.4,0,0,0,0-.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 31,
    y: 48,
    width: 12.97,
    height: 2.5,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.44,45.44a.4.4,0,0,0-.57,0l-3,3-1-1a.4.4,0,0,0-.56,0l-1.2,1.21a.39.39,0,0,0,0,.56l2.44,2.44a.39.39,0,0,0,.56,0l4.52-4.52a.39.39,0,0,0,0-.56Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 66,
    height: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMEncuestas);
export default __webpack_public_path__ + "static/media/m_encuestas.f4cd1baf8fe9398ce6c13bc7c79d70b4.svg";
export { ForwardRef as ReactComponent };